// extracted by mini-css-extract-plugin
export default {"typesList":"styled_typesList__9kjo3","typeContainer":"styled_typeContainer__XscyY","type":"styled_type__jC10k","underline":"styled_underline__f0jLe","active":"styled_active__7P3Wp"};